import Header from '../../components/Header';
import { post } from '../../services/api';
import { useState } from 'react';
import GraficoMedidor from '../../components/GraficosPainelBordo/GrafricoMedidor';
import Tabela from '../../components/GraficosPainelBordo/Tabela';
import GraficoBarra from '../../components/GraficosPainelBordo/GraficoBarra';
import DadosAvulsos from '../../components/GraficosPainelBordo/DadosAvulsos';
import GraficoPizza from '../../components/GraficosPainelBordo/GraficoPizza';
import GraficoLinha from '../../components/GraficosPainelBordo/GraficoLinha';
import TabelaServicos from '../../components/GraficosPainelBordo/TabelaServicos';
import "./PainelBordo.css";

function PainelBordo() {

    const [valorPresenteDepartamento, setValorPresenteDepartamento] = useState({});
    const [valorPresenteTotal, setValorPresenteTotal] = useState({});
    const [vendedorCom, setVendedorCom] = useState({});
    const [realizadoIndicador, setRealizadoIndicador] = useState({});
    const [valorServico, setValorServico] = useState({});
    const [evolucaoIndicadorValorPresente, setEvolucaoIndicadorValorPresente] = useState({});
    const [evolucaoIndicadorServicos, setEvolucaoIndicadorServicos] = useState({});
    const [mesAno, setMesAno] = useState({});
    const [load, setLoad] = useState(true);

    const handleFiltrarClick = (filiais, mesAno) => {
        getPainelBordo(filiais, mesAno)
    };

    async function getPainelBordo(filiais, mesAno) {
        try {

            if (filiais && mesAno) {
                const [mes, ano] = mesAno.split('-');

                setMesAno({mes: mes, ano: ano});
                
                setLoad(false);
                
                const requisicao = { filial: filiais, mes: mes, ano: ano };
                const response = await post('/painelbordo/dadospainelbordo', requisicao);
                
                setLoad(true);
                
                if (response.status === 'OK') {
                    setValorPresenteDepartamento(response.valorPresenteDepartamento);
                    setVendedorCom(response.vendedorCom);
                    setRealizadoIndicador(response.realizadoIndicador);
                    setValorServico(response.valorServico);
                    setEvolucaoIndicadorValorPresente(response.evolucaoIndicadorValorPresente);
                    setEvolucaoIndicadorServicos(response.evolucaoIndicadorServicos);
                    setValorPresenteTotal(response.valorPresenteTotal);
                }
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function verificaObjetoVazio(objeto) {
        return Object.keys(objeto).length === 0;
    }

    return (
        <div>
            <Header type="painelBordo" onFiltrarClick={handleFiltrarClick} dadosCarregados={load}/>
            <section className="bg-white">
                <div className='card-graficos'>
                    <GraficoMedidor  dadosGrafico={{
                        titulo: 'Venda Total',
                        realizado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].realizadototal,
                        ideal: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].idealtotal, 
                        meta: verificaObjetoVazio(realizadoIndicador)? 0 : realizadoIndicador[0].metatotal, 
                        projetado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].projetadototal,
                        percentualRealizadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualrealizadototal,
                        percentualProjetadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualprojetadototal
                    }} />
                    <GraficoMedidor  dadosGrafico={{
                        titulo: 'Venda Presente',
                        realizado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].realizadovalorpresente,
                        ideal: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].idealvalorpresente, 
                        meta: verificaObjetoVazio(realizadoIndicador)? 0 : realizadoIndicador[0].metavalorpresente, 
                        projetado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].projetadovalorpresente,
                        percentualRealizadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualrealizadovalorpresente,
                        percentualProjetadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualprojetadovalorpresente
                    }} />
                    <GraficoMedidor  dadosGrafico={{
                        titulo: 'Juros',
                        realizado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].realizadojuros,
                        ideal: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].idealjuros, 
                        meta: verificaObjetoVazio(realizadoIndicador)? 0 : realizadoIndicador[0].metajuros, 
                        projetado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].projetadojuros,
                        percentualRealizadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualrealizadojuros,
                        percentualProjetadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualprojetadojuros
                    }} />
                    <GraficoMedidor  dadosGrafico={{
                        titulo: 'VP Serviços',
                        realizado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].realizadoservicos,
                        ideal: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].idealservicos, 
                        meta: verificaObjetoVazio(realizadoIndicador)? 0 : realizadoIndicador[0].metaservicos, 
                        projetado: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].projetadoservicos,
                        percentualRealizadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualrealizadoservicos,
                        percentualProjetadoMeta: verificaObjetoVazio(realizadoIndicador) ? 0 : realizadoIndicador[0].percentualprojetadoservicos
                    }} />
                </div>
                <div className='container' style={{ padding: '40px' }}>
                    <div className="overflow-x-auto my-6">
                        <div className="table-wrapper">
                            <Tabela dadosTabela={valorPresenteDepartamento} />
                        </div>
                    </div>
                </div>
                <div className='card-graficos'>
                    <DadosAvulsos dados={{ titulo1: 'VP Total', titulo2: 'Vendedor.com', mesAno: mesAno, vpTotal: valorPresenteTotal, vendedorCom: vendedorCom }} />
                    <GraficoBarra dadosGrafico={{ titulo: 'Serviços', dados: valorServico, mesAno: mesAno }} />
                </div>
                <div className='container' style={{ padding: '40px' }}>
                    <div className="overflow-x-auto my-6">
                        <div className="table-wrapper">
                            <TabelaServicos dadosTabelaServicos={valorServico} />
                        </div>
                    </div>
                </div>
                <div className='card-graficos' style={{ paddingBottom: '50px' }}>
                    <GraficoPizza dadosGrafico={{ titulo: 'Departamento', dados: valorPresenteDepartamento }} />
                    <GraficoLinha dadosGrafico={{ titulo: 'Evolução de VP', dados: evolucaoIndicadorValorPresente, mesAno: mesAno }} />
                    <GraficoLinha dadosGrafico={{ titulo: 'Evolução de Serviços', dados: evolucaoIndicadorServicos, mesAno: mesAno }} />
                </div>
            </section>
        </div>
    )
}

export default PainelBordo